import React from 'react';
import PropTypes from 'prop-types';
import SignupContentRow from 'components/SignupContentRow';
import './DistributorSignupSuccess.scss';


export default class UserSignupSuccess extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        window.scrollTo(0,0);
    }

render() {

        const stepCols = [
            {
                index: 1,
                title: 'Business Review',
                isImg: false,
                imgSrc:'',
                panelIcon: 'ion-ios-search',
                panelLabel: 'APPLICATION REVIEW',
                circleStyle: 'first-col',
                desc: [
                    "We’ll review your application",
                    "Once validated, your business will be approved",
                    "We will reach out to you within 5 business days"
                ]
            },
            {
                index: 2,
                title: 'Account Creation & Training',
                isImg: false,
                imgSrc:'',
                panelIcon: 'ion-ios-book-outline',
                panelLabel: 'TAKE TRAINING',
                circleStyle: '',
                desc: [
                    "You’ll receive an email to create a Username/Password for the PRO Portal",
                    "Sign in to complete your online training",
                ]
            },
            {
                index: 3,
                title: 'Sample & Where to Buy',
                isImg: true,
                imgSrc:'https://s3-us-west-2.amazonaws.com/com-noonhome-web/Pro/SignUp/icon-three-gang.jpg',
                panelIcon: '',
                panelLabel: 'RECEIVE $100 OFF A ROOM BUNDLE',
                circleStyle: '',
                desc: [
                    "Once training is complete you will gain access to more resources",
                    "Use your $100 off code for your personal use Room Bundle",
                    "You’ll be able to access Marketing Materials"
                ]
            },
        ];

        return(
            <section className='usignup-success--holder'>
                <div className='uwhiteBox--container'>
                    <div className='uwhite--box'>
                        <div className='u-contents-holder'>
                            <h2 className='usignup-title'>We've received your application</h2>
                            <p>You'll hear back from us within <span className='bold-text'>5 business days</span> and we may contact you at the number or email you provided if any question arise along the way.</p>
                            <div className='content-steps-holder'>
                                <SignupContentRow rCols={stepCols}/>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/DistributorSignupSuccess/index.js